/**
 * Submit Title Upload Module V2
 * Uses localStorage session manager for all data
 */
(function () {
  "use strict";

  // Run once per page (see submission-session-manager.js).
  if (window.submitTitleUploadLoaded) {
    return;
  }
  window.submitTitleUploadLoaded = true;

  function getApplyBasePath() {
    return window.submissionApplyBasePath || "/partners/bloodstream/apply";
  }

  // Upload state
  let uploadedFiles = {
    trailer: [],
    feature: [],
    subtitles: [],
    closedCaptions: [],
  };

  /**
   * Get session manager instance
   */
  function getSessionManager() {
    return window.SubmissionSessionManager;
  }

  /**
   * Initialize the module
   */
  function init() {
    const sessionManager = getSessionManager();

    if (!sessionManager) {
      console.error("Session manager not loaded");
      return;
    }

    // Get container element
    const container = document.querySelector("#submit-title-upload");
    if (!container) {
      return;
    }

    // Check if session was already submitted and redirect if so
    if (sessionManager.checkAndRedirectIfSubmitted()) {
      return; // Exit init - redirect is happening
    }

    // Set current step
    sessionManager.setCurrentStep(2);

    // Initialize file uploads
    initializeFileUploads();

    // Setup navigation
    setupNavigation();

    // Load title info from step 1
    loadTitleInfo();

    // Restore form data from session
    restoreFormData();
  }

  /**
   * Load title information from step 1
   */
  function loadTitleInfo() {
    const sessionManager = getSessionManager();
    if (!sessionManager) return;

    const step1Data = sessionManager.getStepData(1);

    if (!step1Data.title_name) {
      console.log("No title data available");
      return;
    }

    // Update title info card
    const titleName = document.getElementById("title-name");
    const titleYear = document.getElementById("title-year");
    const titleGenres = document.getElementById("title-genres");
    const titlePoster = document.getElementById("title-poster");
    const titlePosterImg = document.getElementById("title-poster-img");
    const titleInfoCard = document.getElementById("title-info-card");
    const imdbIdField = document.getElementById("imdbIdField");

    if (titleName) {
      const decodedTitle = window.HtmlEntityDecoder
        ? window.HtmlEntityDecoder.decode(
            step1Data.title_name || "Unknown Title"
          )
        : step1Data.title_name || "Unknown Title";
      titleName.textContent = decodedTitle;
    }

    if (titleYear && step1Data.year) {
      titleYear.textContent = `Year: ${step1Data.year}`;
    }

    if (titleGenres && step1Data.genres) {
      titleGenres.textContent = `Genres: ${step1Data.genres}`;
    }

    if (titlePosterImg && step1Data.poster_url) {
      titlePosterImg.src = step1Data.poster_url;
      const decodedTitleForAlt = window.HtmlEntityDecoder
        ? window.HtmlEntityDecoder.decode(step1Data.title_name)
        : step1Data.title_name;
      titlePosterImg.alt = `${decodedTitleForAlt} Poster`;
      if (titlePoster) {
        titlePoster.classList.remove("hide");
      }
    }

    if (titleInfoCard) {
      titleInfoCard.classList.remove("hide");
    }

    // Set IMDB ID in hidden field
    if (imdbIdField && step1Data.imdb_id) {
      imdbIdField.value = step1Data.imdb_id;
    }

    console.log("Title info loaded:", step1Data.title_name);
  }

  /**
   * Restore form data from session
   */
  function restoreFormData() {
    const sessionManager = getSessionManager();
    if (!sessionManager) return;

    const step2Data = sessionManager.getStepData(2);

    // Restore trailer link fields
    if (step2Data.trailer_link) {
      document.getElementById("trailer_link").value = step2Data.trailer_link;
    }
    if (step2Data.trailer_password) {
      document.getElementById("trailer_password").value =
        step2Data.trailer_password;
    }

    // Restore feature link fields
    if (step2Data.feature_link) {
      document.getElementById("feature_link").value = step2Data.feature_link;
    }
    if (step2Data.feature_password) {
      document.getElementById("feature_password").value =
        step2Data.feature_password;
    }

    // Restore upload notes
    if (step2Data.upload_notes) {
      document.getElementById("upload_notes").value = step2Data.upload_notes;
    }

    // Restore uploaded files state
    if (step2Data.trailer_uploads) {
      uploadedFiles.trailer = step2Data.trailer_uploads;
    }
    if (step2Data.feature_uploads) {
      uploadedFiles.feature = step2Data.feature_uploads;
    }
    if (step2Data.subtitle_uploads) {
      uploadedFiles.subtitles = step2Data.subtitle_uploads;
    }
    if (step2Data.closed_caption_uploads) {
      uploadedFiles.closedCaptions = step2Data.closed_caption_uploads;
    }

    console.log("Form data restored from session");
  }

  /**
   * Initialize file uploads
   */
  function initializeFileUploads() {
    // File uploads are handled by file-upload.js component
    // Attach event listeners to .file-upload-area divs (where events are dispatched)

    const trailerArea = document.querySelector(
      '.file-upload-area[data-input-name="trailer_upload"]'
    );
    const featureArea = document.querySelector(
      '.file-upload-area[data-input-name="feature_upload"]'
    );
    const subtitleArea = document.querySelector(
      '.file-upload-area[data-input-name="subtitle_upload"]'
    );
    const closedCaptionArea = document.querySelector(
      '.file-upload-area[data-input-name="closed_caption_upload"]'
    );

    if (trailerArea) {
      trailerArea.addEventListener("fileuploaded", function (e) {
        const fileData = e.detail;
        console.log("✅ Trailer file uploaded:", fileData);
        uploadedFiles.trailer.push(fileData);
        console.log("📦 Current uploaded files:", uploadedFiles);
      });

      trailerArea.addEventListener("fileremove", function (e) {
        console.log("❌ Trailer file removed");
        uploadedFiles.trailer = [];
        console.log("📦 Current uploaded files:", uploadedFiles);
      });
    } else {
      console.warn("Trailer upload area not found");
    }

    if (featureArea) {
      featureArea.addEventListener("fileuploaded", function (e) {
        const fileData = e.detail;
        console.log("✅ Feature file uploaded:", fileData);
        uploadedFiles.feature.push(fileData);
        console.log("📦 Current uploaded files:", uploadedFiles);
      });

      featureArea.addEventListener("fileremove", function (e) {
        console.log("❌ Feature file removed");
        uploadedFiles.feature = [];
        console.log("📦 Current uploaded files:", uploadedFiles);
      });
    } else {
      console.warn("Feature upload area not found");
    }

    if (subtitleArea) {
      subtitleArea.addEventListener("fileuploaded", function (e) {
        const fileData = e.detail;
        console.log("✅ Subtitle file uploaded:", fileData);
        uploadedFiles.subtitles.push(fileData);
        console.log("📦 Current uploaded files:", uploadedFiles);
      });

      subtitleArea.addEventListener("fileremove", function (e) {
        console.log("❌ Subtitle file removed");
        uploadedFiles.subtitles = [];
        console.log("📦 Current uploaded files:", uploadedFiles);
      });
    } else {
      console.warn("Subtitle upload area not found");
    }

    if (closedCaptionArea) {
      closedCaptionArea.addEventListener("fileuploaded", function (e) {
        const fileData = e.detail;
        console.log("✅ Closed caption file uploaded:", fileData);
        uploadedFiles.closedCaptions.push(fileData);
        console.log("📦 Current uploaded files:", uploadedFiles);
      });

      closedCaptionArea.addEventListener("fileremove", function (e) {
        console.log("❌ Closed caption file removed");
        uploadedFiles.closedCaptions = [];
        console.log("📦 Current uploaded files:", uploadedFiles);
      });
    } else {
      console.warn("Closed caption upload area not found");
    }

    console.log("🎯 File upload listeners attached");
  }

  /**
   * Setup navigation buttons
   */
  function setupNavigation() {
    const sessionManager = getSessionManager();
    if (!sessionManager) return;

    const backButton = document.getElementById("back-button");
    const continueButton = document.getElementById("upload-submit");

    if (backButton) {
      backButton.addEventListener("click", function (e) {
        e.preventDefault();
        sessionManager.navigateWithSession(`${getApplyBasePath()}/imdb`);
      });
    }

    if (continueButton) {
      // Prevent duplicate event listener attachment
      if (continueButton.dataset.initialized === "true") {
        console.log("[Upload] Continue button already initialized, skipping");
        return;
      }
      continueButton.dataset.initialized = "true";

      continueButton.addEventListener("click", function (e) {
        e.preventDefault();
        handleContinue();
      });
    }
  }

  /**
   * Handle continue button click
   */
  async function handleContinue() {
    const sessionManager = getSessionManager();
    if (!sessionManager) return;

    // Collect form data
    const formData = {
      trailer_link: document.getElementById("trailer_link")?.value || "",
      trailer_password:
        document.getElementById("trailer_password")?.value || "",
      feature_link: document.getElementById("feature_link")?.value || "",
      feature_password:
        document.getElementById("feature_password")?.value || "",
      upload_notes: document.getElementById("upload_notes")?.value || "",
      trailer_uploads: uploadedFiles.trailer,
      feature_uploads: uploadedFiles.feature,
      subtitle_uploads: uploadedFiles.subtitles,
      closed_caption_uploads: uploadedFiles.closedCaptions,
    };

    // Validate: Movie (feature) is required, trailer is optional
    // Must have EITHER uploaded files OR a valid link (not empty string)
    const hasFeatureUpload = uploadedFiles.feature.length > 0;
    const hasFeatureLink = formData.feature_link.trim().length > 0;
    const hasFeature = hasFeatureUpload || hasFeatureLink;

    // Debug logging
    console.log("[Upload Validation]");
    console.log("  - Feature uploads:", uploadedFiles.feature);
    console.log("  - Feature link:", formData.feature_link);
    console.log(
      "  - Feature link trimmed length:",
      formData.feature_link.trim().length
    );
    console.log("  - Has feature upload?", hasFeatureUpload);
    console.log("  - Has feature link?", hasFeatureLink);
    console.log("  - Has feature (either)?", hasFeature);

    if (!hasFeature) {
      console.error("[Upload Validation] FAILED - No feature film provided");
      showNotification(
        "Please upload your movie (feature film). This is required to continue.",
        "warning"
      );
      return;
    }

    console.log("[Upload Validation] PASSED ✓");

    // Trailer is optional - no validation needed
    console.log("Validation passed - Feature provided:", hasFeature);

    // Save to session
    sessionManager.saveStepData(2, formData);
    sessionManager.markStepCompleted(2);

    console.log("Step 2 data saved:", formData);

    try {
      // WAIT for persistence to complete
      await persistStepData(2, formData);

      console.log("[Step 2] Successfully persisted to database");

      // Navigate to customize page ONLY after successful persistence
      sessionManager.navigateWithSession(`${getApplyBasePath()}/customize`);
    } catch (error) {
      console.error("[Step 2] Failed to persist to database:", error);
      showNotification("Failed to save your data. Please try again.", "error");
      // Don't navigate - let user retry
    }
  }

  /**
   * Show notification
   */
  function showNotification(message, type = "info") {
    const notification = document.createElement("div");
    notification.className = `callout ${type} has-icon`;
    notification.style.cssText =
      "position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px;";
    notification.innerHTML = `
      <div class="callout-icon">
        <i class="fas fa-${
          type === "success"
            ? "check-circle"
            : type === "error"
            ? "exclamation-circle"
            : "info-circle"
        }"></i>
      </div>
      <div class="callout-content">
        <p>${String(message === null || message === undefined ? "" : message).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}</p>
      </div>
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.remove();
    }, 5000);
  }

  /**
   * Persist step data to database
   */
  async function persistStepData(stepNumber, formData) {
    const sessionManager = getSessionManager();
    try {
      const response = await fetch("/api/submissions/save-step", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uuid: sessionManager.getSessionId(),
          step: stepNumber,
          form_data: formData,
        }),
      });

      const result = await response.json();

      if (!result.success) {
        console.error(
          "[Step " + stepNumber + "] Database persistence failed:",
          result.message
        );
        return false;
      }

      console.log(
        "[Step " + stepNumber + "] Successfully persisted to database"
      );
      return true;
    } catch (error) {
      console.error(
        "[Step " + stepNumber + "] Error persisting to database:",
        error
      );
      throw error;
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
